export default function toSecondsIsoString(date: Date) {
    return date.toISOString().slice(0, -5) + 'Z' // Remove milliseconds from ISO string
}
